import React from 'react'
import { Hero } from '../Components/Hero/Hero'
import { Borokinni } from '../Components/Borokinni/Borokinni'
import { Newsletter } from '../Components/Newsletter/Newsletter'

export const Shop = () => {
  return (
    <div>
        <Hero/>
        <Borokinni/>
        <Newsletter/>     
    </div>
  )
}
